import Q18 from './Q18';

export default Q18;
